import { useTranslation } from 'react-i18next'

import { Sitzungsstand } from '../komponenten/Sitzungsstand'

/**
 * Die Startseite des Rahmens.
 *
 * Sie zeigt, dass Auslieferung, Branding und Sprachen zusammenspielen — mehr
 * nicht. IS-34 ersetzt sie durch die eigentliche Huelle mit Navigation und
 * Nutzermenue.
 */
export function Start() {
  const { t } = useTranslation()

  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center gap-6 px-6 py-16">
      <div className="rounded-imp border border-line-strong bg-surface p-8 shadow-sm">
        <p className="text-sm tracking-wide text-text-muted uppercase">{t('rahmen.app.zone')}</p>
        <h1 className="mt-1 text-3xl">{t('rahmen.app.name')}</h1>

        <p className="mt-6 text-xl text-heading">{t('rahmen.start.titel')}</p>
        <p className="mt-2 text-text-muted">{t('rahmen.start.einleitung')}</p>

        <div className="mt-6 border-t border-line pt-4">
          <Sitzungsstand />
        </div>

        <div className="mt-6 flex items-center justify-between gap-4 border-t border-line pt-4">
          <span className="text-sm text-text-muted">
            {t('rahmen.start.version', { version: __APP_VERSION__ })}
          </span>
          {/*
            Kein <Link>: /docs ist die gebaute MkDocs-Doku und liegt ausserhalb
            der SPA (app/main.py). Ein Router-Link wuerde sie nicht laden,
            sondern ins Leere der Wegekarte laufen.
          */}
          <a
            className="font-semibold text-accent underline underline-offset-4 hover:text-accent-hover"
            href="/docs/"
          >
            {t('rahmen.start.doku')}
          </a>
        </div>
      </div>
    </main>
  )
}
